<template>
  <div>
    <div class="container-fluid m-0 p-0">
       <div class="row justify-content-center">
        <div class="col-md-2 t-center mt-5 pt-5">
          <img src="@/assets/so.png" alt="CompTIA S+ Logo" class="img-fluid mb-3"
          />
        </div>
      </div>

      <div class="row bg-white pt-5 pb-5 ms-5 border-bottom">
        <div class="col-md-1 p-0 t-center">Kapitel</div>
        <div class="col-md-2 p-0 t-center">PDF</div>
        <div class="col-md-3 p-0 t-center">Bezeichnung</div>
      </div>

      <div class="row ms-5" v-for="i in 22" :key="i">
        <div class="col-md-1 p-0 t-center">{{ i }}</div>
        <div class="col-md-2 p-0 t-center">
          <a :href="`/PDF/${$data['PDF' + i]}`" download v-if="$data['PDF' + i]">
            <button class="btn btn-success p-1 m-1" style="min-width: 100px">
              PDF {{ i }}
            </button>
          </a>

          <a
            :href="`/PDF/${$data['PDF' + i + 'a']}`"
            download
            v-if="$data['PDF' + i + 'a']"
          >
            <button class="btn btn-success p-1 m-1" style="min-width: 100px">
              PDF {{ i }}
            </button>
          </a>
        </div>
        <div class="col-md-8 p-0 t-center">
          {{ $data["Titel" + i] }}
        </div>

     
      </div>
   
      
      
    </div>
  </div>
</template>

<script>
export default {
  name: "KapitelfragenQuizPage_S_Plus",

  data() {
    return {
      newSite: null,
      Titel1: "TerminalFix Berlin IT  Eine Ausarbeitung zum IT-Zwischenfall in der Verwaltung von Berlin",
      Titel2: "HTTP3 Troubleshooting - Eine Analyse der neuen HTTP-Version und deren Problem ",
      Titel3: "Linux Befehle - Eine umfassende Anleitung zu den wichtigsten Linux-Befehlen",
      Titel4: "RAID_Gesamtübersicht - Eine Übersicht der verschiedenen RAID-Level und deren Einsatzmöglichkeiten",
      Titel5: "TPM - Security verschlüsselung - Eine Analyse der Trusted Platform Module und deren Einsatz in der IT-Sicherheit",
      Titel6: "Überblick der WLAN-Standards - Eine Zusammenfassung der verschiedenen WLAN-Standards und deren Eigenschaften",
      Titel7: "Vergleich VLAN Subnetting zu Macfilter",
      Titel8: "IP_Klassen_A-D - Eine Erklärung der verschiedenen IP-Klassen und deren Verwendung",
      Titel9: "DHCP_DORA_Grundlagen - Eine Einführung in den DHCP-Prozess und dessen Funktionsweise",
      Titel10: "DNS_Ablauf - Eine Erklärung des DNS-Auflösungsprozesses",
      Titel11: "OSI-Layer - Eine Erklärung der verschiedenen Schichten des OSI-Modells & TCP/IP-Modells",
      Titel12: "Demoprojekt - Aufbau mit Switches, Radius-Server, NAC und Clients",
      Titel13: "DSGVO Vorfälle 2025-2026 - Eine Analyse der Datenschutzvorfälle in den Jahren 2025 und 2026",
      Titel14: "IP4-Netzwerklassen - Eine Erklärung der verschiedenen IP4-Netzwerklassen.",
      Titel15: "",
      Titel16: "",
      Titel17: "",
      Titel18: "",
      Titel19: "",
      Titel20: "",
      Titel21: "",
      Titel22: "",
     
      PDF1: "TerminalFix_Berlin_IT-Unterricht.pdf",
      PDF2: "HTTP3_Troubleshooting.pdf",
      PDF3: "Linux_Befehle_Vollstaendig.pdf",
      PDF4: "RAID_Gesamtübersicht.pdf",
      PDF5: "TPM - Security verschlüsselung.pdf",
      PDF6: "Überblick der WLAN-Standards.pdf",
      PDF7: "Vergleich VLAN Subnetting zu Macfilter.pdf",
      PDF8: "17-x - IP4-Netzwerklassen.pdf",
      PDF9: "17 - x - DHCP_DORA_Grundlagen.pdf",
      PDF10: "17 - x - DNS_Ablauf.pdf",
      PDF11: "OSI-Layer.pdf",
      PDF12: "Demoprojekt.pdf",
      PDF13: "DSGVO-vorfälle2025-2026.pdf",
      PDF14: "",
      PDF15: "",
      PDF16: "",
      PDF17: "",
      PDF18: "",
      PDF19: "",
      PDF20: "",
      PDF21: "",
      PDF22: "",

    };
  },
  components: {},
  methods: {},
  computed: {},
};
</script>

<style scoped></style>
